"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2084],{

/***/ 72084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22934);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40706);
/* harmony import */ var src_common_utils_responsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7010);






var Index = function() {
    var customer_support = _config__WEBPACK_IMPORTED_MODULE_3__/* .LANDING_PAGE_DATA.customer_support */ .BF.customer_support;
    var isMobile = (0,src_common_utils_responsive__WEBPACK_IMPORTED_MODULE_4__/* .useViewport */ .S)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().customerSupportSection),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sectionTitle),
                        style: {
                            marginBottom: "unset",
                            padding: isMobile ? "0 20px" : ""
                        },
                        children: customer_support.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: isMobile ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().customerSupportHighlight) : (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().customerSupportHighlight),
                        children: customer_support.colored_text
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().customerSupportSubtitle),
                        children: customer_support.subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().phoneImageContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: customer_support === null || customer_support === void 0 ? void 0 : customer_support.image_url,
                    height: isMobile ? "300px" : "360px",
                    width: isMobile ? "360px" : "420px"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

}]);